const themeObj = {
    1: {
        primary: '#FF6600',
        mainBg: 'linear-gradient(90deg, #ff6600 0%, #ff8f45 100%)'
    },
    2: {
        primary: '#791122',
        mainBg: '#ffffff'
    },
}
export const setTheme = (index=1) => {
    const theme = themeObj[index] || themeObj[1]
    document.documentElement.style.setProperty('--el-color-primary',theme.primary)
    document.documentElement.style.setProperty('mainBg',theme.mainBg)
}